import Model from '@/models/Model'

export default class HrPreviredApv extends Model {
    resource() {
        return 'hr_previred_apv'
    }
}